export enum ECompanyTypeNameConst {
  SITE_OPERATION = 'Site Operations',
  DESIGNER = 'Designer',
  CHECKER = 'Checker',
  SYSTEM_USERS = 'GEMS System Users',
  VIEWERS = 'Viewers',
  REVIEWERS = 'Reviewers',
}
export enum ECompanyTypeIdConst {
  SITE_OPERATION = 1,
  DESIGNER = 3,
  CHECKER = 4,
  SYSTEM_USERS = 5,
  VIEWERS = 8,
  REVIEWERS = 9,
  PLACEHOLDER = 10,
}

export enum ECompanyCodeConst {
  GEMS_SYSTEM_USERS = 'GSU',
  LAMBETH = 'LAL',
  SITE_OPERATION = 'GCL',
  SITE_DESIGN_TEAM = 'GCD',
  SITE_CHECKER = 'GCC',
  LAMBETH_CHECKER = 'LDC',
  VIEWERS = 'CRA',
  REVIEWERS = 'REVW',
}
